export class ProductImage {
    id: number;
    product_id: number;
    image: string;
    sort_order: number;
    created_at: string;
    updated_at: string;
}



// WEBPACK FOOTER //
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/models/shop/product_image.ts